import { withIdentity } from "flavours/glitch/identity_context";
import PropTypes from "prop-types";
import { PureComponent } from "react";

import ServerBanner from "flavours/glitch/components/server_banner";
import SearchContainer from "flavours/glitch/features/compose/containers/search_container";

// Side panel of the wide single-column layout. Writing happens in the pop-out
// composer (compose_popout.jsx), so the panel holds the search.
class ComposePanel extends PureComponent {

  static propTypes = {
    identity: PropTypes.object,
  };

  render() {
    const { signedIn } = this.props.identity;

    return (
      <div className='compose-panel'>
        {signedIn && <SearchContainer openInRoute />}

        {!signedIn && (
          <>
            <ServerBanner />
            <div className='flex-spacer' />
          </>
        )}

      </div>
    );
  }

}

export default withIdentity(ComposePanel);
